import { DeletionLabels, ALERT_TYPE } from "../common/constants/common";
import IModal from "./IModal";

export function DeleteConfirmationModal({
  isOpen,
  onCancel,
  submitHandler,
  children,
  type = ALERT_TYPE.DELETE,
  loading = false,
}: {
  isOpen: boolean;
  onCancel: () => void;
  submitHandler: () => void;
  children: any;
  type?: ALERT_TYPE;
  loading?: boolean;
}) {
  return (
    <IModal
      isOpen={isOpen}
      onClose={onCancel}
      header={{
        title: `Confirm ${DeletionLabels[type].title}`,
      }}
      deleteButton={{
        label: DeletionLabels[type].label,
        props: {
          onClick: submitHandler,
          isLoading: loading,
          isDisabled: loading,
        },
      }}
      secondaryButton={{
        label: "Cancel",
        props: {
          onClick: onCancel,
        },
      }}
    >
      {children}
    </IModal>
  );
}
